import { isCustomerKycVerified } from "../components/customer/CustomerKycSection";
import { shouldShowCustomerAadhaarKycUi } from "../config/customerAccessPolicy";

export function isCustomerKycSubmitted(status, kycStatus = {}) {
  const s = String(status || kycStatus?.kycStatus || "").toUpperCase();
  if (s === "SUBMITTED" || s === "IN_REVIEW") return true;
  return Boolean(
    kycStatus?.submittedAt &&
      kycStatus?.documents?.frontUploaded &&
      kycStatus?.documents?.backUploaded &&
      !isCustomerKycVerified(s)
  );
}

/** Booking gate message — null when B2C (KYC not required). Preserved for B2B flag. */
export function getCustomerKycBookingMessage(kycStatus = {}) {
  if (!shouldShowCustomerAadhaarKycUi()) return null;
  if (isCustomerKycVerified(kycStatus?.kycStatus) || kycStatus?.verified) {
    return null;
  }
  if (isCustomerKycSubmitted(kycStatus?.kycStatus, kycStatus)) {
    return "Your Aadhaar KYC is under admin review. You can book caregivers once it is approved.";
  }
  return "Complete Aadhaar KYC in your profile before booking a caregiver.";
}

function isUsableProfileName(value) {
  const name = String(value || "").trim();
  if (!name) return false;
  // Reject mobile/OTP placeholders mistakenly stored as the name.
  const compact = name.replace(/\s+/g, "");
  if (/^\d{8,}$/.test(compact)) return false;
  return true;
}

export { isUsableProfileName };

function isValidProfileEmail(value) {
  const email = String(value || "").trim();
  if (!email) return true; // email is optional
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

/** Booking gate: full name + mobile only. Email and other fields are optional. */
export function isCustomerProfileComplete(profile = {}) {
  if (!profile || typeof profile !== "object") return false;
  const firstName = String(
    profile.firstName || profile.fullName || profile.name || ""
  ).trim();
  const mobile = String(profile.mobile || profile.phone || "").replace(/\D/g, "");
  return Boolean(isUsableProfileName(firstName) && /^\d{10}$/.test(mobile));
}

export function isCustomerSubscriptionActive(billingSnapshot = {}) {
  const status = String(billingSnapshot?.subscriptionStatus || "").toUpperCase();
  if (status === "ACTIVE") return true;
  return Boolean(billingSnapshot?.subscription?.active);
}

export function shouldPromptCustomerSubscription(profile, _kycStatus, billingSnapshot = {}) {
  if (!isCustomerProfileComplete(profile)) return false;
  if (isCustomerSubscriptionActive(billingSnapshot)) return false;
  return Boolean(
    billingSnapshot?.month2SubscriptionDue ||
      billingSnapshot?.subscription?.month2SubscriptionDue
  );
}

export function getCustomerSubscriptionHint({ profileComplete, kycVerified, month2Due } = {}) {
  if (!profileComplete) {
    return "Complete your profile (full name and mobile) to continue.";
  }
  if (shouldShowCustomerAadhaarKycUi() && !kycVerified) {
    return "Complete Aadhaar KYC, then book a caregiver from Marketplace. After acceptance, pay the ₹3,000 security deposit to unlock OTP and start service.";
  }
  if (month2Due) {
    return "Renew or upgrade a Care Pass from Care Passes for the patient you want to book.";
  }
  return "Add patients under Patients, purchase a Care Pass linked to that patient ID, then book from Marketplace.";
}
